export default __webpack_public_path__ + "static/media/rightArrowSecondary.8c7a96ea.svg";